import React from 'react'
import PropTypes from 'prop-types'

import { THIRD_PARTY_TAG, VAST_TAG_URL } from '../../../../fields'

import useStyles from './styles'

const ThirdPartySectionPreview = ({ ad }) => {
  const classes = useStyles()

  return <div className={classes.thirdPartyTagPreview}>{ad[THIRD_PARTY_TAG] || ad[VAST_TAG_URL]}</div>
}

ThirdPartySectionPreview.propTypes = {
  ad: PropTypes.object
}

export default ThirdPartySectionPreview
